import React from "react";
import { Route, Redirect } from "react-router-dom";
import AuthTemplate from "./AuthTemplate";

const PublicRoute = ({ component, ...props }) => (
  <Route
    {...props}
    render={() =>
      !localStorage.getItem("access_token") ? (
        <AuthTemplate component={component} {...props} />
      ) : (
        <Redirect to="/" />
      )
    }
  />
);

export default PublicRoute;
